import { getCarStoryShareUrl } from './shareMeta'

import type { IMycleContentDetailResponse } from '../model/home'
import type { Metadata } from 'next'

interface IBuildCarStoryContentMetadataArgs {
  contentId: number
  detail: IMycleContentDetailResponse
}

export const buildCarStoryContentMetadata = ({
  contentId,
  detail,
}: IBuildCarStoryContentMetadataArgs): Metadata => {
  const url = getCarStoryShareUrl(contentId)
  const title = detail.title
  const description = detail.kakaoShareDescription ?? ''
  const imageUrl = detail.thumbnailUrl

  return {
    title,
    description,
    alternates: { canonical: url },
    openGraph: {
      title,
      description,
      url,
      locale: 'ko_KR',
      type: 'article',
      ...(imageUrl ? { images: [{ url: imageUrl }] } : {}),
    },
    twitter: {
      card: 'summary_large_image',
      title,
      description,
      ...(imageUrl ? { images: [imageUrl] } : {}),
    },
  }
}
